import { connect } from "react-redux";

import {
    Form,
    FormElement,
    FormValidator,
    BaseReactComponent,
    SelectControl,
    CustomTextControl
} from "../../utils/form";
import { Row, Col, Tabs, } from "react-bootstrap";
import ComponentHeader from "../common/ComponentHeader";
import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom";
import { FEATURE, isModuleExist, MODULE_ID_MAP, } from "../../utils/Constant";
import { isPartnerAllowed, safeParseJson, } from "../../utils/ReusableFunctions";
import { toast } from "react-toastify";
import { fetchModuleFeatures } from "./Api";
import { withRouter } from "../../utils/hoc/withRouter";
import { getAllSsoPartnersApi } from "../sso/Api";
import { postLoginInstance } from "../../utils";
import ReactSelect from "react-select";
import { postAuthCommonApi, putAuthCommonApi } from "../content/Api";

const SOCIALS_MAP = {
    "FACEBOOK": [FEATURE.AUTO_COBRAND_FACEBOOK, FEATURE.PLATFORM_FACEBOOK, FEATURE.POST_FACEBOOK],
    "LINKEDIN": [FEATURE.AUTO_COBRAND_LINKEDIN, FEATURE.PLATFORM_LINKEDIN, FEATURE.POST_LINKEDIN],
    "TWITTER": [FEATURE.AUTO_COBRAND_TWITTER, FEATURE.PLATFORM_TWITTER, FEATURE.POST_TWITTER],
    "EMAIL": [FEATURE.AUTO_COBRAND_EMAIL, FEATURE.PLATFORM_EMAIL, FEATURE.POST_EMAIL],
    "WHATSAPP": [FEATURE.AUTO_COBRAND_WHATSAPP, FEATURE.PLATFORM_WHATSAPP, FEATURE.POST_WHATSAPP],
    "INSTAGRAM": [FEATURE.AUTO_COBRAND_INSTAGRAM, FEATURE.PLATFORM_INSTAGRAM, FEATURE.POST_INSTAGRAM],
}



class SubloginRoleForm extends BaseReactComponent {
    constructor(props) {
        super(props);
        const AccesData = isModuleExist(MODULE_ID_MAP.RoleChildRole);
        const editData = props.location.state?.editData || {};
        let partners = this.loadDefaultPartners(AccesData)
        if (editData?.partners?.list) {
            partners = editData?.partners
        }

        this.state = {
            AccessData: AccesData,
            childRoleName: editData?.childRoleName || "",
            childRoleFeatures: [],
            partners,
            formLoading: false,
            editData,
            platforms: [],
        };
    }




    async componentDidMount() {
        getAllSsoPartnersApi(this)
        fetchModuleFeatures(this);
        const fetchData = async () => {
            const platforms = await postLoginInstance.get("/website/platform");
            this.setState({ platforms: platforms?.data?.data?.list || [] });
        }
        fetchData();
    }

    componentDidUpdate(prevProps, prevState) {


    }


    handleSave = () => {
        ReactDOM.findDOMNode(this.form).dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
        );
    };

    validate = async () => {

        return null;

    }

    onValidSubmit = async () => {
        const error = await this.validate();
        if (error) {
            toast.error(error)
            return;
        }
        this.setState({ formLoading: true });

        const payload = {
            "data": {
                "childRoleName": this.state.childRoleName,
                "childRoleFeatures": this.state.childRoleFeatures?.map(f => ({
                    featureId: f.featureId,
                    isEnabled: f.isEnabled,
                    useParent: f.useParent,
                    config: f.config || "{}"
                })) || [],
                "partners": this.state.partners || []
            }
        }


        if (!isPartnerAllowed(this.state.AccessData?.id)) {
            delete payload.data.partners;
        }

        if (this.state.editData?.uuid) {
            const response = await putAuthCommonApi(`childRole/${this.state.editData?.uuid}`, payload);
            if (response.status < 250 && response.status > 199) {
                this.setState({ resLoading: false });
                this.props.history({ pathname: `/child-role` });
            } else {
                this.setState({ resLoading: false });
            }

        } else {
            const response = await postAuthCommonApi('/childRole', payload);
            if (response.status < 250 && response.status > 199) {
                this.setState({ resLoading: false });
                this.props.history({ pathname: `/child-role` });
            }
            else {
                this.setState({ resLoading: false });
            }

        }

        this.setState({ formLoading: false });

    };
    getFeatureByCode = (featureCode) => this.state?.childRoleFeatures?.find(f => f.featureCode === featureCode);
    hasFeature = (featureCode) => this.state?.childRoleFeatures?.find(f => f.featureCode === featureCode)?.isEnabled;

    updateFeature = (featureCode, changes) => {
        const feature = this.getFeatureByCode(featureCode);
        this.setState({
            childRoleFeatures: this.state.childRoleFeatures.map(f => f.featureCode === feature?.featureCode ? { ...f, ...changes } : f)
        })
    }


    setBrandingTemplatesPermissions = (value) => {
        if (!value) {
            this.updateFeature(FEATURE.COBRAND_TEMPLATES, { isEnabled: false });
            this.updateFeature(FEATURE.CUSTOM_TEMPLATES, { isEnabled: false });
            this.updateFeature(FEATURE.DEFAULT_TEMPLATE_SET, { isEnabled: false });
        }
        this.setState({ brandingTemplatesPermissions: value })
    }

    setUserGeneratedContentEnabled = (value) => {
        this.setState({ userGeneratedContentEnabled: value })
    }



    updateUsageConfig = (section, value, type) => {
        const currentConfig =
            safeParseJson(this.getFeatureByCode(FEATURE.USAGE_BREAKDOWN)?.config) || {};

        const existingSection = currentConfig[section] || { Free: 0, Premium: 0, "Free,Premium": 0 };

        const newSection = { ...existingSection, [type]: Number(value) };

        this.updateFeature(FEATURE.USAGE_BREAKDOWN, {
            config: JSON.stringify({
                ...currentConfig,
                [section]: newSection
            })
        });
    };



    render() {

        const { isLoading, brandingTemplatesPermissions, userGeneratedContentEnabled } = this.state;
        const { getFeatureByCode, hasFeature, updateFeature, setBrandingTemplatesPermissions,
            setUserGeneratedContentEnabled, updateUsageConfig } = this;

        const usageBreakdownConfig =
            this.getFeatureByCode(FEATURE.USAGE_BREAKDOWN)?.config
                ? safeParseJson(this.getFeatureByCode(FEATURE.USAGE_BREAKDOWN)?.config)
                : {};
        console.log(this.state);
        if (isLoading) {
            return (
                <section className="add-section">
                    <ComponentHeader
                        title={"Loading Roles Form..."}
                        isSearch={false}
                        isBackArrow={true}
                        isReturn="/child-role"
                        handlePrimaryBtn={this.handleSave}
                    />
                </section>
            )
        }
        return (
            <section className="add-section child-role">
                <ComponentHeader
                    title={this.props?.match?.params?.uuid ? "Update Role" : "Add Role"}
                    primaryBtn="Save"
                    isSearch={false}
                    isBackArrow={true}
                    resLoading={this.state.formLoading}
                    isReturn="/child-role"
                    handlePrimaryBtn={this.handleSave}
                />
                <Form ref={(el) => (this.form = el)} onValidSubmit={this.onValidSubmit}>


                    <Row>
                        <Col md={12}>
                            {isPartnerAllowed(this.state.AccessData?.id) &&
                                <Col md={4}>
                                    <FormElement
                                        valueLink={this.linkState(this, "partners.list")}
                                        label="Publish To Partner(s)"
                                        required
                                        validations={[
                                            {
                                                validate: FormValidator.isRequired,
                                                message: "Publish To cannot be empty",
                                            },
                                        ]}
                                        control={{
                                            type: SelectControl,
                                            settings: {
                                                options: this.state?.ssoPartnersOptions || [],
                                                placeholder: "Select Partner(s)",
                                                multiple: true,
                                                searchable: true,
                                                selectAll: true,
                                                onChangeCallback: (onBlur) => {
                                                },
                                            },
                                        }}
                                    />

                                </Col>}
                            <Col md={4}>
                                <FormElement
                                    valueLink={this.linkState(this, "childRoleName")}
                                    label="Role Name"
                                    required
                                    validations={[
                                        {
                                            validate: FormValidator.isRequired,
                                            message: "Role Name cannot be empty",
                                        },
                                    ]}
                                    control={{
                                        type: CustomTextControl,
                                        settings: {
                                            type: "text",
                                            placeholder: "Enter Role Name",
                                        },
                                    }}
                                />
                            </Col>

                            <Col md={12}> <Tabs
                                className="mobile-tabs"
                                id="mobile-tabs"
                            >
                                <Tabs.Tab eventKey={"account"} title={"Account"}>
                                    <div className="account-wrapper main">
                                        <h1 className="f-s-16 lato-bold">Profile Details</h1>
                                        <p className="f-s-12 fade-text">Allow Child to update profile details?</p>
                                        <div className="my-3 mt-4">

                                        </div>
                                        <div className="d-flex gap-12 flex-column editable-fields">
                                            <div className={`option ${hasFeature(FEATURE.PERSONAL_DETAILS) ? "active" : ""}`} onClick={() => {
                                                updateFeature(FEATURE.PERSONAL_DETAILS, { isEnabled: !hasFeature(FEATURE.PERSONAL_DETAILS) })
                                            }}>
                                                <p className="f-s-14 lato-semibold">Edit Profile Details</p>
                                            </div>
                                            <div className={`option ${hasFeature(FEATURE.COMPANY_DETAILS) ? "active" : ""}`} onClick={() => {
                                                updateFeature(FEATURE.COMPANY_DETAILS, { isEnabled: !hasFeature(FEATURE.COMPANY_DETAILS) })
                                            }}>
                                                <p className="f-s-14 lato-semibold">Edit Company Details</p>
                                            </div>
                                        </div>
                                    </div>
                                </Tabs.Tab>
                                <Tabs.Tab eventKey={"permissions"} title={"Permissions"}>

                                    <div className="permission-wrapper">
                                        <ToggleRow
                                            title="Personalization"
                                            subtitle="Allow Child to access Personalization?"
                                            checked={hasFeature(FEATURE.PERSONALIZATION_TOGGLE)}
                                            onChange={() => updateFeature(FEATURE.PERSONALIZATION_TOGGLE, { isEnabled: !hasFeature(FEATURE.PERSONALIZATION_TOGGLE) })}
                                        />
                                        <hr />
                                        <p className="f-s-16 lato-bold padding-left mb-3">Notification</p>
                                        <ToggleRow
                                            title="Custom Notifications"
                                            subtitle="Allow Child to access Custom Notifications?"
                                            checked={hasFeature(FEATURE.CUSTOM_NOTIFICATION)}
                                            onChange={() => updateFeature(FEATURE.CUSTOM_NOTIFICATION, { isEnabled: !hasFeature(FEATURE.CUSTOM_NOTIFICATION) })}
                                        />
                                        <ToggleRow
                                            title="Usage Alert Notifications"
                                            subtitle="Allow Child to access Usage Alert Notifications?"
                                            checked={hasFeature(FEATURE.USAGE_ALERT_NOTIFICATION)}
                                            onChange={() => updateFeature(FEATURE.USAGE_ALERT_NOTIFICATION, { isEnabled: !hasFeature(FEATURE.USAGE_ALERT_NOTIFICATION) })}
                                        />
                                        <hr />
                                        <ToggleRow
                                            title="Event"
                                            subtitle="Allow Child to access Event?"
                                            checked={hasFeature(FEATURE.EVENT_SELECTION)}
                                            onChange={() => updateFeature(FEATURE.EVENT_SELECTION, { isEnabled: !hasFeature(FEATURE.EVENT_SELECTION) })}
                                        />
                                        <hr />
                                        <ToggleRow
                                            title="Trending"
                                            subtitle="Allow Child to access Trending?"
                                            checked={hasFeature(FEATURE.TRENDING_TOGGLE)}
                                            onChange={() => updateFeature(FEATURE.TRENDING_TOGGLE, { isEnabled: !hasFeature(FEATURE.TRENDING_TOGGLE) })}
                                        />
                                        <hr />
                                        <ToggleRow
                                            title="Calculators"
                                            subtitle="Allow Child to access Calculators?"
                                            checked={hasFeature(FEATURE.TOOLS_SELECTION)}
                                            onChange={() => updateFeature(FEATURE.TOOLS_SELECTION, { isEnabled: !hasFeature(FEATURE.TOOLS_SELECTION) })}
                                        />
                                        <hr />
                                        {/* Campaign Planner */}
                                        <ToggleRow
                                            title="Campaign planner"
                                            subtitle="Allow Child to access Campaign planner?"
                                            checked={hasFeature(FEATURE.CAMPAIGN_SELECTION)}
                                            onChange={() => updateFeature(FEATURE.CAMPAIGN_SELECTION, { isEnabled: !hasFeature(FEATURE.CAMPAIGN_SELECTION) })}
                                        />
                                        {hasFeature(FEATURE.CAMPAIGN_SELECTION) && <div className="padding-left">
                                            <p className="section-hint">
                                                Select campaign type permissions your child can access
                                            </p>
                                            <PillGroup
                                                options={[{ label: "Free Campaign", value: FEATURE.FREE_PLAYLIST }, { label: "Paid Campaign", value: FEATURE.PAID_PLAYLIST }]}
                                                active={[FEATURE.FREE_PLAYLIST, FEATURE.PAID_PLAYLIST].filter(f => hasFeature(f))}
                                                onClick={(val) => updateFeature(val, { isEnabled: !hasFeature(val) })}

                                            />
                                        </div>}

                                        {/* User Generated Content */}
                                        {hasFeature(FEATURE.CAMPAIGN_SELECTION) && <ToggleRow
                                            title="User generated content"
                                            subtitle="Allow Child to generate content?"
                                            checked={userGeneratedContentEnabled}
                                            onChange={() => setUserGeneratedContentEnabled(!userGeneratedContentEnabled)}
                                        />}
                                        {hasFeature(FEATURE.CAMPAIGN_SELECTION) && userGeneratedContentEnabled && <div className="padding-left">

                                            <p className="section-hint">
                                                Select custom content generation permissions
                                            </p>
                                            <PillGroup
                                                options={[
                                                    { label: "Upload own content", value: FEATURE.MANUAL_CONTENT },
                                                    { label: "Create content on canvas", value: FEATURE.CANVAS_CONTENT },
                                                    { label: "Create content using AI", value: FEATURE.AI_CONTENT },
                                                ]}
                                                active={[FEATURE.MANUAL_CONTENT, FEATURE.CANVAS_CONTENT, FEATURE.AI_CONTENT].filter(f => hasFeature(f))}
                                                onClick={(val) => updateFeature(val, { isEnabled: !hasFeature(val) })}
                                            />
                                        </div>}
                                        <hr />
                                        {/* Cobranding */}
                                        <ToggleRow
                                            title="Cobranding Permissions"
                                            subtitle="Allow Child to Cobrand?"
                                            checked={hasFeature(FEATURE.CONTENT_COBRAND)}
                                            onChange={() => updateFeature(FEATURE.CONTENT_COBRAND, { isEnabled: !hasFeature(FEATURE.CONTENT_COBRAND) })}
                                        />
                                        {hasFeature(FEATURE.CONTENT_COBRAND) && <ToggleRow
                                            id={"branding"}
                                            title=""
                                            subtitle="Configure branding templates permissions"
                                            checked={brandingTemplatesPermissions}
                                            onChange={() => setBrandingTemplatesPermissions(!brandingTemplatesPermissions)}
                                        />}

                                        {brandingTemplatesPermissions && <div className="padding-left mb-4">
                                            <PillGroup
                                                options={[
                                                    { label: "Select Templates", value: FEATURE.COBRAND_TEMPLATES },
                                                    { label: "Save Custom Templates", value: FEATURE.CUSTOM_TEMPLATES },
                                                    { label: "Set Default Template", value: FEATURE.DEFAULT_TEMPLATE_SET },
                                                ]}
                                                active={[FEATURE.COBRAND_TEMPLATES, FEATURE.CUSTOM_TEMPLATES, FEATURE.DEFAULT_TEMPLATE_SET].filter(f => hasFeature(f))}
                                                onClick={(val) => updateFeature(val, { isEnabled: !hasFeature(val) })}
                                            />
                                        </div>}

                                        <ToggleRow
                                            title="Auto Cobrand"
                                            subtitle="Allow Child to access Auto Cobrand?"
                                            checked={hasFeature(FEATURE.AUTO_COBRAND_UPLOAD)}
                                            onChange={() => updateFeature(FEATURE.AUTO_COBRAND_UPLOAD, { isEnabled: !hasFeature(FEATURE.AUTO_COBRAND_UPLOAD) })}
                                        />
                                        {/* Preferences */}
                                        <ToggleRow
                                            title="My Preferences"
                                            subtitle="Allow Child to access My Preferences?"
                                            checked={hasFeature(FEATURE.PREFERENCE_TOGGLE)}
                                            onChange={() => updateFeature(FEATURE.PREFERENCE_TOGGLE, { isEnabled: !hasFeature(FEATURE.PREFERENCE_TOGGLE) })}
                                        />
                                        {hasFeature(FEATURE.PREFERENCE_TOGGLE) && <div className="padding-left d-flex flex-column gap-16 preference-group">

                                            <div className="d-flex gap-12 mb-2">
                                                <p className="f-s-14">Profile details</p>
                                                {/* <CustomPortalDropdown
                                                    className="common-dropdown"
                                                    icon
                                                    options={[
                                                        { label: "Use my preference (Parent)", value: "parent" },
                                                        { label: "Allow to set their own", value: "own" },
                                                    ]}
                                                    label={getFeatureByCode(FEATURE.PROFILE_PREFERENCE)?.useParent ? "Use my preference (Parent)" : "Allow to set their own"}
                                                    onSelect={
                                                        (val) => {
                                                            updateFeature(FEATURE.PROFILE_PREFERENCE, { useParent: val === "parent" })
                                                        }
                                                    }
                                                /> */}
                                                <ReactSelect
                                                    value={getFeatureByCode(FEATURE.PROFILE_PREFERENCE)?.useParent ? {
                                                        label: "Use my preference (Parent)",
                                                        value: "parent"
                                                    } : {
                                                        label: "Allow to set their own",
                                                        value: "own"
                                                    }}
                                                    onChange={
                                                        (selected) => {
                                                            updateFeature(FEATURE.PROFILE_PREFERENCE, { useParent: selected.value === "parent" })
                                                        }
                                                    }

                                                    options={[{
                                                        label: "Use my preference (Parent)",
                                                        value: "parent"
                                                    }, {
                                                        label: "Allow to set their own",
                                                        value: "own"

                                                    }]}
                                                    placeholder={"Select an option"}
                                                    classNamePrefix={`custom-select`}
                                                />


                                            </div>

                                            <div className="d-flex gap-12 mb-2">
                                                <p className="f-s-14">Content</p>
                                                {/* <CustomPortalDropdown
                                                    className="common-dropdown"
                                                    icon
                                                    options={[
                                                        { label: "Use my preference (Parent)", value: "parent" },
                                                        { label: "Allow to set their own", value: "own" },
                                                    ]}
                                                    label={getFeatureByCode(FEATURE.CONTENT_PREFERENCE)?.useParent ? "Use my preference (Parent)" : "Allow to set their own"}
                                                    onSelect={
                                                        (val) => {
                                                            updateFeature(FEATURE.CONTENT_PREFERENCE, { useParent: val === "parent" })
                                                        }
                                                    }
                                                /> */}
                                                <ReactSelect
                                                    value={getFeatureByCode(FEATURE.CONTENT_PREFERENCE)?.useParent ? {
                                                        label: "Use my preference (Parent)",
                                                        value: "parent"
                                                    } : {
                                                        label: "Allow to set their own",
                                                        value: "own"
                                                    }}
                                                    onChange={
                                                        (selected) => {
                                                            updateFeature(FEATURE.CONTENT_PREFERENCE, { useParent: selected.value === "parent" })
                                                        }
                                                    }

                                                    options={[{
                                                        label: "Use my preference (Parent)",
                                                        value: "parent"
                                                    }, {
                                                        label: "Allow to set their own",
                                                        value: "own"
                                                    }]}
                                                    placeholder={"Select an option"}
                                                    classNamePrefix={`custom-select`}
                                                />
                                            </div>

                                            <div className="d-flex gap-12 mb-2">
                                                <p className="f-s-14">Branding</p>
                                                {/* <CustomPortalDropdown
                                                    className="common-dropdown"
                                                    icon
                                                    options={[
                                                        { label: "Use my preference (Parent)", value: "parent" },
                                                        { label: "Allow to set their own", value: "own" },
                                                    ]}
                                                    label={getFeatureByCode(FEATURE.BRANDING_PREFERENCE)?.useParent ? "Use my preference (Parent)" : "Allow to set their own"}
                                                    onSelect={
                                                        (val) => {
                                                            updateFeature(FEATURE.BRANDING_PREFERENCE, { useParent: val === "parent" })
                                                        }
                                                    }
                                                /> */}
                                                <ReactSelect
                                                    value={getFeatureByCode(FEATURE.BRANDING_PREFERENCE)?.useParent ? {
                                                        label: "Use my preference (Parent)",
                                                        value: "parent"
                                                    } : {
                                                        label: "Allow to set their own",
                                                        value: "own"
                                                    }}
                                                    onChange={
                                                        (selected) => {
                                                            updateFeature(FEATURE.BRANDING_PREFERENCE, { useParent: selected.value === "parent" })
                                                        }
                                                    }

                                                    options={[{
                                                        label: "Use my preference (Parent)",
                                                        value: "parent"
                                                    }, {
                                                        label: "Allow to set their own",
                                                        value: "own"
                                                    }]}
                                                    placeholder={"Select an option"}
                                                    classNamePrefix={`custom-select`}
                                                />

                                            </div>
                                        </div>}

                                    </div>
                                </Tabs.Tab>
                                <Tabs.Tab eventKey={"usage"} title={"Usage"}>
                                    <div className="usage-wrapper form-group">
                                        <ToggleRow
                                            title="Download Permission"
                                            subtitle="Select whether child is allowed to download"
                                            checked={hasFeature(FEATURE.USAGE_BREAKDOWN)}
                                            onChange={() => updateFeature(FEATURE.USAGE_BREAKDOWN, { isEnabled: !hasFeature(FEATURE.USAGE_BREAKDOWN) })}
                                        />
                                        {
                                            hasFeature(FEATURE.USAGE_BREAKDOWN) &&
                                            <>
                                                {
                                                    [FEATURE.CONTENT_DOWNLOAD, FEATURE.PERSONALIZATION_TOGGLE, FEATURE.EVENT_SELECTION, FEATURE.TOOLS_SELECTION].find(f => hasFeature(f)) ?
                                                        <div className="my-4 padding-left">

                                                        </div> :
                                                        null
                                                }
                                                <div className="padding-left">
                                                    {[FEATURE.USAGE_BREAKDOWN].find(f => hasFeature(f)) &&
                                                        <p className="f-s-12 fade-text">Configure usage allowance limit</p>}

                                                    <div className="inputs mt-4 d-flex gap-24 flex-column">
                                                        <div className="input">
                                                            <p className="f-s-14 lato-semibold">Free Content
                                                            </p>
                                                            <input
                                                                type="text"
                                                                value={usageBreakdownConfig?.Content?.Free ?? ""}
                                                                onChange={(e) => {
                                                                    if (!/^\d*$/.test(e.target.value)) return;
                                                                    updateUsageConfig("Content", e.target.value, "Free");
                                                                }}
                                                                className="form-control mt-1"
                                                            />
                                                        </div>

                                                        <div className="input">
                                                            <p className="f-s-14 lato-semibold">Premium Content

                                                            </p>
                                                            <input
                                                                type="text"
                                                                value={usageBreakdownConfig?.Content?.Premium ?? ""}
                                                                onChange={(e) => {
                                                                    if (!/^\d*$/.test(e.target.value)) return;
                                                                    updateUsageConfig("Content", e.target.value, "Premium");
                                                                }}
                                                                className="form-control mt-1"
                                                            />
                                                        </div>
                                                        {hasFeature(FEATURE.EVENT_SELECTION) && (
                                                            <div className="input">
                                                                <p className="f-s-14 lato-semibold">Premium Event
                                                                </p>
                                                                <input
                                                                    type="text"
                                                                    value={usageBreakdownConfig?.Event?.Premium ?? ""}
                                                                    onChange={(e) => {
                                                                        if (!/^\d*$/.test(e.target.value)) return;
                                                                        updateUsageConfig("Event", e.target.value, "Premium");
                                                                    }}
                                                                    className="form-control mt-1"
                                                                />
                                                            </div>
                                                        )}
                                                        {hasFeature(FEATURE.PERSONALIZATION_TOGGLE) && (
                                                            <div className="input">
                                                                <p className="f-s-14 lato-semibold">Free, Premium Personalization

                                                                </p>
                                                                <input
                                                                    type="text"
                                                                    value={usageBreakdownConfig?.Personalization?.["Free,Premium"] ?? ""}
                                                                    onChange={(e) => {
                                                                        if (!/^\d*$/.test(e.target.value)) return;
                                                                        updateUsageConfig("Personalization", e.target.value, "Free,Premium");
                                                                    }}
                                                                    className="form-control mt-1"
                                                                />
                                                            </div>
                                                        )}
                                                        {hasFeature(FEATURE.TOOLS_SELECTION) && (
                                                            <div className="input">
                                                                <p className="f-s-14 lato-semibold">Free, Premium Calculators

                                                                </p>
                                                                <input
                                                                    type="text"
                                                                    value={usageBreakdownConfig?.Tools?.["Free,Premium"] ?? ""}
                                                                    onChange={(e) => {
                                                                        if (!/^\d*$/.test(e.target.value)) return;
                                                                        updateUsageConfig("Tools", e.target.value, "Free,Premium");
                                                                    }}
                                                                    className="form-control mt-1"
                                                                />
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>
                                            </>}
                                    </div>
                                </Tabs.Tab>
                                <Tabs.Tab eventKey={"socials"} title={"Socials"}>
                                    {
                                        !(hasFeature(FEATURE.CAMPAIGN_SELECTION) || hasFeature(FEATURE.AUTO_COBRAND_UPLOAD)) &&
                                        <div className="padding-left mt-4">
                                            <p className="red-FB2 f-s-14">
                                                Allow Campaign planner or Auto Co-brand access to Enable social media permissions
                                            </p>
                                        </div>
                                    }
                                    <div className="socials-wrapper padding-left">
                                        <h5 className="f-s-16 lato-bold">Social Media</h5>
                                        <p className="f-s-12 fade-text">Social platform access and linking permissions for content sharing </p>
                                        {(hasFeature(FEATURE.CAMPAIGN_SELECTION) || hasFeature(FEATURE.AUTO_COBRAND_UPLOAD)) && <div className="mt-5">
                                            {this.state?.platforms.map(p => (
                                                <>
                                                    <div key={p.id} className="d-flex gap-12 flex-column flex-md-row align-items-center">
                                                        <ToggleRow
                                                            id={p.code}
                                                            padding={false}
                                                            title={
                                                                <div className="d-flex align-items-center gap-8">
                                                                    <div className="platform-icon">
                                                                        <img src={p.iconImagePath} width={20} />
                                                                    </div>
                                                                    <span className="f-s-14 lato-regular">{p.platformName}</span>
                                                                </div>
                                                            }
                                                            checked={SOCIALS_MAP[p.code]?.find(f => hasFeature(f))}
                                                            onChange={(checked) => {
                                                                const featuresToUpdate = SOCIALS_MAP[p.code] || [];
                                                                featuresToUpdate.forEach(feature => {
                                                                    updateFeature(feature, { isEnabled: checked })
                                                                }
                                                                )
                                                            }}
                                                        />
                                                        {/* <CustomPortalDropdown
                                                            className="common-dropdown"
                                                            icon
                                                            options={[
                                                                { label: "Use my preference (Parent)", value: "parent" },
                                                                { label: "Allow to set their own", value: "own" },
                                                            ]}
                                                            label={SOCIALS_MAP[p.code]?.find(f => getFeatureByCode(f)?.useParent) ? "Use my preference (Parent)" : "Allow to set their own"}
                                                            onSelect={(val) => {
                                                                const featuresToUpdate = SOCIALS_MAP[p.code] || [];
                                                                featuresToUpdate.forEach(feature => {
                                                                    updateFeature(feature, { useParent: val === "parent" })
                                                                }
                                                                )
                                                            }
                                                            }
                                                        /> */}
                                                        <ReactSelect
                                                            value={SOCIALS_MAP[p.code]?.find(f => getFeatureByCode(f)?.useParent) ? {
                                                                label: "Use my preference (Parent)",
                                                                value: "parent"
                                                            } : {
                                                                label: "Allow to set their own",
                                                                value: "own"
                                                            }}
                                                            onChange={(selected) => {
                                                                const featuresToUpdate = SOCIALS_MAP[p.code] || [];
                                                                featuresToUpdate.forEach(feature => {
                                                                    updateFeature(feature, { useParent: selected.value === "parent" })
                                                                }
                                                                )
                                                            }
                                                            }
                                                            options={[{
                                                                label: "Use my preference (Parent)",
                                                                value: "parent"
                                                            }, {
                                                                label: "Allow to set their own",
                                                                value: "own"
                                                            }]}
                                                            placeholder={"Select an option"}
                                                            classNamePrefix={`custom-select`}
                                                        />

                                                    </div>
                                                    <hr className="w-100" />
                                                </>
                                            ))}
                                        </div>}
                                    </div>

                                </Tabs.Tab>
                            </Tabs>
                            </Col>
                        </Col>
                    </Row>
                </Form>
            </section>
        );
    }
}

const ToggleRow = ({ title, subtitle, padding = true, onChange, checked, id }) => (
    <div className={`toggle-row ${padding ? "padding-left" : ""}`}>
        <div>
            <h6 className="f-s-14 inter-semibold">{title}</h6>
            <p className="f-s-12 fade-text">{subtitle}</p>
        </div>
        <ToggleSwitch
            id={id || title?.toString()?.toLowerCase().replace(/\s/g, "-")}
            onChange={(e) => {
                onChange(e.target.checked)
            }}
            checked={checked}
        />
    </div>
);
const ToggleSwitch = ({ id, checked, onChange, className, disabled = false }) => {
    return (<div>
        <input
            type="checkbox"
            id={id}
            checked={checked}
            disabled={disabled}
            className="d-none"
            onChange={onChange}
        />
        <label htmlFor={id} className={`toggle-btn ${disabled ? "disabled" : ""} ${checked ? "n-active" : ""} ${className}`}>
            <div className="toggle-circle"></div>
        </label>
    </div>
    )
}




const PillGroup = ({ options, active, onClick = () => { }, }) => (
    <div className="pill-group">
        {options.map((opt) => (
            <div
                onClick={() => onClick(opt.value)}
                key={opt.value}
                className={`pill ${active?.includes(opt.value) ? "active" : ""}`}
            >
                {opt.label}
            </div>
        ))}
    </div>
);

const mapStateToProps = (state) => ({
    masterCategoryState: state.MasterCategoryState,
    subloginState: state.SubloginState
});

const mapDispatchToProps = {


};


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubloginRoleForm));
